import React from 'react'
import HeroSection from './sections/HeroSection'
import ServicesSection from './sections/ServicesSection'
import AboutSection from './sections/AboutSection'
import ApproachSection from './sections/ApproachSection'
import InsightsSection from './sections/InsightsSection'
import CTASection from './sections/CTASection'

const Body: React.FC = () => {
  return (
    <main>
      <HeroSection />
      <ServicesSection />
      <AboutSection />
      <ApproachSection />
      <InsightsSection />
      <CTASection />
    </main>
  )
}

export default Body